import { NgModule } from '@angular/core';
import { NbDialogModule } from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { InventoryComponent } from './inventory.component';
import { InventoryRoutingModule } from './inventory-routing.module';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { CompaniesService } from '../manage/companies/companies.service';

@NgModule({
  declarations: [
    InventoryComponent
  ],
  imports: [
    CommonModule,
    InventoryRoutingModule,
    NgbPaginationModule,
    SharedModule,
    NbDialogModule.forRoot()
  ],
  providers: [
    CompaniesService
  ],
  entryComponents: []
})
export class InventoryModule { }
